import { useEffect } from 'react';

interface MobileReadyRouteProps {
  children: JSX.Element;
}

export const MobileReadyRoute = ({ children }: MobileReadyRouteProps): JSX.Element => {
  const body = document.querySelector('body');

  useEffect(
    function removeMinWidth() {
      if (body) {
        body.classList.add('mobile-ready');
      }

      return function cleanUpClass() {
        if (body) {
          body.classList.remove('mobile-ready');
        }
      };
    },
    [body],
  );

  return children;
};
